export const getDevice = () => {
  return 'desktop-web';
};

export const getUserLocale = () => {
  let userLocale: any =
    navigator.languages && navigator.languages.length
      ? navigator.languages[0]
      : navigator.language;

  userLocale = userLocale.split('-');

  return userLocale[1];
};
